// Estilos de los tickets que se imprimen desde el navegador en la ticketera
// termica (80 mm). Courier New fino a 12px salia gris/borroso: la termica
// convierte los trazos delgados en puntos sueltos. Se usa una fuente sans en
// negrita, negro puro y algo mas grande para que el texto quede oscuro y nitido.
export const TICKET_CSS = `
  @page { size: 80mm auto; margin: 0; }
  * { color: #000 !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  body {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: 700;
    font-size: 13px;
    line-height: 1.35;
    width: 72mm;
    margin: 0 auto;
    padding: 2mm;
    -webkit-font-smoothing: none;
  }
  .center { text-align: center; }
  .right { text-align: right; white-space: nowrap; }
  .bold { font-weight: 900; }
  .line { border-top: 2px dashed #000; margin: 6px 0; }
  table { width: 100%; border-collapse: collapse; }
  td { padding: 2px 0; vertical-align: top; font-weight: 700; }
`;
